import axios from "axios";
import cachios from "cachios";

const cacheAxiosInstance = axios.create({
	baseURL: 'https://api.aref-medical.com'
})

export const cachiosInstance = cachios.create(cacheAxiosInstance);
